import { Component, Input, OnChanges } from '@angular/core';

import { PanelState } from '@global/infrastructure/interfaces/panel-state';



@Component({
  selector: 'app-feature-wrapper',
  templateUrl: './feature-wrapper.component.html',
  styleUrls: ['./feature-wrapper.component.scss']
})
export class FeatureWrapperComponent implements OnChanges {

  @Input() panelConfig: PanelState;
  @Input() policyId: string;
  @Input() isProgressing = false;
  @Input() policyChangeDate: Date;
  @Input() journeyPath: any;

  featureIndex = 0;
  currentFeatures: string[] = [];
  totalPages: number;
  titleIcon: string;
  showProgressBar: boolean;

  onActivate(event) {
    window.scroll(0, 0);
  }

  ngOnChanges(): void {
    this.currentFeatures = this.journeyPath.path;
    this.totalPages = this.currentFeatures.length - 1;
    this.featureIndex = this.currentFeatures.indexOf(this.panelConfig.breadcrumbFeatureName);
    this.titleIcon = this.panelConfig.icon;
    this.showProgressBar =
      ['stopYourRenewal', 'reviewYourDetails'].indexOf(
        this.panelConfig.breadcrumbFeatureName
      ) > -1;
  }
}
